<template>
  <b-form @submit.prevent="validateBeforeSubmit" novalidate v-on:keyup.esc="editField(false)" v-click-outside="editField">
    <inline-edit class="mb-0" field="name" :doEdit="edit" @editField="editField" @saveField="validateBeforeSubmit">
      <span slot="content"><span v-html="description"></span> <i v-if="!description">Smelltu hér til að skrá</i></span>
      <span slot="input">
        <quill-editor id="description" name="description" v-model="text" ref="descriptionQuillEditor" :options="editorOption">
        </quill-editor>
      </span>
    </inline-edit>
  </b-form>
</template>

<script>
import { mapActions } from 'vuex';

import { quillEditor } from 'vue-quill-editor';
import vClickOutside from 'v-click-outside';
import core from '@/api/core';
import InlineEdit from '@/components/InlineEdit.vue';

export default {
  name: 'profession-description-edit',
  components: {
    quillEditor,
    InlineEdit,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: ['description', 'professionId'],
  data() {
    return {
      edit: false,
      text: null,
      editorOption: {
        /* quill options */
      },
    };
  },
  methods: {
    async validateBeforeSubmit() {
      try {
        // Engar villur í formi.
        try {
          await core.professionDescriptionUpdate(this.professionId, {
            description: this.text,
          });
          // this.description = this.text;
          this.displaySuccess('Starfalýsing uppfærð');
          this.$emit('successful', {});
          this.text = null;
          this.edit = false;
        } catch (e) {
          // Aðgerð mistókst.
          this.$log.debug(e);
          this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
        } finally {
          this.loading = false;
        }
      } catch (e) {
        // Villur í formi.
        this.$log.debug(e);
      }
    },
    editField({ doEdit }) {
      if (doEdit) {
        this.edit = true;
        this.text = this.description;
      } else {
        this.edit = false;
        this.text = null;
      }
    },
    /**
     * Annað
     */
    ...mapActions(['displaySuccess', 'displayError']),
  },
};
</script>

<style></style>
